import {axios, HOST, config} from './settiing';

export default {
  getAdminList() {
    return axios.get( `${HOST}/resource/admin`, config);
  },
  getAdminListByRole(service) {
    return axios.get( `${HOST}/resource/admin/by/${service}`, config);
  },
  updateAdmin(data) {
    return axios.put(`${HOST}/resource/admin`, data, config);
  },
  addAdmin(data) {
    return axios.post(`${HOST}/resource/admin`, data, config);
  },
  getCenterAdmin(loginId, centerId, authority) {
    return axios.get(`${HOST}/resource/admin/${loginId}/${centerId}/${authority}`, config);
  },
  getAdmin(loginId) {
    return axios.get(`${HOST}/resource/admin/get/${loginId}`, config);
  },
  deleteAdmin(id){
    return axios.delete(`${HOST}/resource/admin/${id}`, config);
  },
  checkMyPassword(password) {
    return axios.get(`${HOST}/resource/admin/checkPassword?password=${password}`,  config);
  },
  getLoginedAdmin(){
    return axios.get(`${HOST}/resource/admin/getAdmin`, config);
  },
}